import { DatePicker } from '@rio-cloud/rio-uikit';
import TableSearch from '@rio-cloud/rio-uikit/TableSearch';
import TableToolbar from '@rio-cloud/rio-uikit/TableToolbar';
import TableViewToggles from '@rio-cloud/rio-uikit/TableViewToggles';

import Paginator from '../../components/Paginator';
import { ICoin } from '../../types/coins';
import CustomHeader from './components/CustomHeader';
import CustomTable from './components/CustomTable';

import Button from "@rio-cloud/rio-uikit/Button";
import Notification from '@rio-cloud/rio-uikit/Notification';
import moment from "moment";
import React from "react";
import { useControll } from './useControll';

const PointsScreen = () => {
  const {
    fieldSort,
    sort,
    totalScore,
    totalPages,
    searchValue,
    page,
    dataChart,
    challengeDrivers,
    PAGE_SIZE,

    startDate,
    endDate,
    setStartDate,
    setEndDate,

    handlePage,
    setFieldSort,
    setSort,
    setPage,
    handleSearchValueChange,
    handleDownload,
    loading,
  } = useControll();



  const handleSort = (key: string) => {
    const typedKey = key as keyof ICoin;
    if (fieldSort === typedKey) {
      setSort({ [fieldSort]: sort[fieldSort] === 'asc' ? 'desc' : 'asc' });
    } else {
      setFieldSort(typedKey);
      setSort({ [typedKey]: 'asc' });
    }
  };

  const handlePageChange = (newPage: number) => {
    if (newPage < 1 || newPage > totalPages) return;
    setPage(newPage);
  };

  const inputProps1: React.HTMLProps<HTMLInputElement> = {
    placeholder: 'Data Inicial',
    id: '1',
    style: { width: 120, paddingLeft: '30px' }
  };

  const inputProps2: React.HTMLProps<HTMLInputElement> = {
    placeholder: 'Data Final',
    id: '2',
    style: { width: 120, paddingLeft: '30px' }
  };

  const handleReset = () => {
    setStartDate(undefined);
    setEndDate(undefined);
  };

  const validateDateRange = (start: string, end: string) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays > 30) {
      Notification.info('O período de pesquisa não pode exceder 30 dias');
      return false;
    }
    return true;
  };

  const isValidEndDate = (current: moment.Moment) => {
    if (!startDate) return true;
    const start = moment(startDate);
    const daysDiff = current.diff(start, 'days');
    return daysDiff >= 0 && daysDiff <= 30;
  };

  if (!startDate) inputProps1.value = '';
  if (!endDate) inputProps2.value = '';

  return (
    <div className="min-h-screen">
      <div className="padding-20 page-content-container">
        <div className="margin-bottom-10">
          <TableToolbar>
            <div className="table-toolbar-container">
              <div className="table-toolbar-group-left">
                <div className="table-toolbar-column">
                  <div className="btn-toolbar table-btn-toolbar">
                    <div className="width-400">
                      <TableSearch
                        className="width-100pct"
                        value={searchValue}
                        onChange={handleSearchValueChange}
                        placeholder="Buscar por motorista"
                      />
                    </div>
                  </div>
                </div>
                <div className="table-toolbar-column">
                  <div className="btn-toolbar table-btn-toolbar">
                    <div className="gap-10 display-flex align-items-center">
                      <div className="margin-0">
                        <DatePicker
                          inputProps={inputProps1}
                          dateFormat="DD/MM/YYYY"
                          timeFormat={false}
                          locale="pt-BR"
                          value={startDate ? moment(startDate) : undefined}
                          onChange={(value: moment.Moment | string, isValid: boolean) => {
                            if (isValid && moment.isMoment(value)) {
                              const newStartDate = value.format('YYYY-MM-DD');
                              setStartDate(newStartDate);

                              const autoEndDate = moment(value).add(30, 'days').format('YYYY-MM-DD');
                              setEndDate(autoEndDate);
                            } else {
                              setStartDate(undefined);
                            }
                          }}
                        />
                      </div>
                      <div className="margin-0">
                        <DatePicker
                          className="padding-left-0 border-color-black"
                          inputProps={inputProps2}
                          dateFormat="DD/MM/YYYY"
                          timeFormat={false}
                          locale="pt-BR"
                          value={endDate ? moment(endDate) : undefined}
                          isValidDate={isValidEndDate}
                          onChange={(value: moment.Moment | string, isValid: boolean) => {
                            if (isValid && moment.isMoment(value)) {
                              const newEndDate = value.format('YYYY-MM-DD');
                              setEndDate(newEndDate);
                            } else {
                              setEndDate(undefined);
                            }
                          }}
                        />
                      </div>
                      <Button
                        onClick={handleReset}
                        bsStyle={Button.PRIMARY}
                        className="rioglyph rioglyph-trash"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-toolbar-group-right">
                <div className="table-toolbar-column table-toolbar-column-spacer">
                  <button
                    type="button"
                    className="btn btn-default btn-icon-only"
                    onClick={handleDownload}
                  >
                    <span
                      className="rioglyph rioglyph-download"
                      aria-hidden="true"
                    ></span>
                  </button>
                </div>
                <div className="table-toolbar-column">
                  <TableViewToggles
                    initialViewType={"TABLE"}
                    onViewTypeChange={() => { }}
                    tableViewTooltipContent="Tabela"
                    singleCardViewTooltipContent="Lista"
                    multiCardsViewTooltipContent="Cards"
                  />
                </div>
              </div>
            </div>
          </TableToolbar>
        </div>

        <div className="page-header-container margin-bottom-20">
          <CustomHeader value={totalScore} title="A frota tem" dataChart={dataChart} />
        </div>

        <div className="table-content-container">
          <CustomTable
            isLoading={loading}
            trips={challengeDrivers}
            page={page}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            sortBy={fieldSort}
            sortDir={sort[fieldSort]}
            onSort={handleSort}
            searchValue={searchValue}
            onSearchChange={handleSearchValueChange}
          />
          <Paginator
            pageSize={PAGE_SIZE}
            handlePage={handlePage}
            page={page}
            pages={totalPages}
            disabled={challengeDrivers.length == 0}
          />
        </div>
      </div>
    </div>
  );
};

export default PointsScreen;